export default __webpack_public_path__ + "static/media/quote.2e107b49.svg";